import { useReactFlow } from '@xyflow/react'
import { useCallback, useEffect, useRef } from 'react'

import { SoundClipNodeData } from '../../../converters/shared/reactFlowTypes'
import { withSoundClipSelection } from './soundClipSelection'

/**
 * Hook for Sound Clip node functionality.
 * Handles sound clip ID selection.
 */
export const useSoundClipNode = (id: string, data: SoundClipNodeData) => {
  const { updateNodeData } = useReactFlow()
  const dataRef = useRef(data)

  useEffect(() => {
    dataRef.current = data
  }, [data])

  const currentSoundClipId = data.soundClipId || ''

  const handleSoundClipChange = useCallback(
    (soundClipId: string | undefined, soundClipUuid: string | undefined) => {
      updateNodeData(
        id,
        withSoundClipSelection(dataRef.current, soundClipId, soundClipUuid),
        { replace: true },
      )
    },
    [id, updateNodeData],
  )

  return {
    currentSoundClipId,
    handleSoundClipChange,
    hasData: !!currentSoundClipId,
  }
}
